<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Detalhes da Operação"
    show-back
    back-aria-label="Fechar detalhes da operação">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="operation-details-drawer" *ngIf="!isLoading && details; else loadingState">
      <div class="operation-details-drawer__badges">
        <b3-tag
          size="sm"
          variant="filled"
          [icon]="operationTypeBadge.icon"
          [tone]="operationTypeBadge.tone"
          [label]="operationTypeBadge.label">
        </b3-tag>
        <b3-tag
          *ngIf="showAcxSourceBadge"
          size="sm"
          variant="filled"
          tone="info"
          icon="check_circle"
          label="ACX">
        </b3-tag>
        <b3-tag
          *ngIf="showBrcerBadge"
          size="sm"
          variant="filled"
          tone="info"
          icon="check_circle"
          label="BRCER">
        </b3-tag>
      </div>

      <div class="operation-details-drawer__grid operation-details-drawer__grid--2">
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">Data de emissão</span>
          <span class="operation-details-drawer__value">{{ details.issueDate }}</span>
        </div>
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">CPF/CNPJ do Comitente</span>
          <span class="operation-details-drawer__value">{{ details.comitenteDocumentNumber }}</span>
        </div>
      </div>

      <div class="operation-details-drawer__grid operation-details-drawer__grid--2">
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">Qtd. Emitida</span>
          <span class="operation-details-drawer__value">{{ details.creditInitialQuantity }}</span>
        </div>
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">Qtd. Atual</span>
          <span class="operation-details-drawer__value">{{ details.creditQuantity }}</span>
        </div>
      </div>

      <div class="operation-details-drawer__grid operation-details-drawer__grid--2">
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">Início da Safra (Vintage)</span>
          <span class="operation-details-drawer__value">{{ details.vintageStart }}</span>
        </div>
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">Fim da Safra (Vintage)</span>
          <span class="operation-details-drawer__value">{{ details.vintageEnd }}</span>
        </div>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">Serial Range</span>
        <span class="operation-details-drawer__value">{{ details.serialCode }}</span>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">Link do projeto na certificadora</span>
        <a
          *ngIf="projectLink && projectLink !== '-'; else emptyProjectLink"
          class="operation-details-drawer__link"
          [href]="projectLink"
          target="_blank"
          rel="noopener noreferrer">
          {{ projectLink }}
        </a>
        <ng-template #emptyProjectLink>
          <span class="operation-details-drawer__value">-</span>
        </ng-template>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">Nome da Certificadora</span>
        <span class="operation-details-drawer__value">{{ details.certifierDescription }}</span>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">Descrição adicional</span>
        <p class="operation-details-drawer__value operation-details-drawer__value--description">
          {{ details.observationText }}
        </p>
      </div>

      <div class="operation-details-drawer__actions">
        <b3-button
          class="operation-details-drawer__confirm-btn"
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="close()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Entendi
        </b3-button>
      </div>
    </div>

    <ng-template #loadingState>
      <p class="operation-details-drawer__loading">Carregando detalhes da operação...</p>
    </ng-template>
  </b3-drawer-body>
</b3-drawer>
